import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'
import { GetCurrencySchema } from '@repo/schema/currency'

const CurrenciesResponseSchema = getDataWrapperSchema(GetCurrencySchema.array())

export const createFinancialsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    currencies: {
      get: p.path('currencies').query(({ path, upFetch }) =>
        upFetch(path, {
          schema: CurrenciesResponseSchema,
        }),
      ),
    },
  }
}
